import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ETipoPreferencia, ETipoProducto } from 'src/app/models/enums.enum';
import { IItem, IPreferencia } from 'src/app/models/interfaces-apis/diccionarios';
import { GrupoPreferenciaComponent } from '../../../form-componentes/grupo-preferencia/grupo-preferencia.component';
import { IFichaCliente, IPreferenciaCliente } from 'src/app/models/interfaces-apis/ficha_cliente';
import { ObservacionesComponent } from '../../../form-componentes/observaciones/observaciones.component';
import { SelectSearchMaterialComponent } from '../../../form-componentes/material-framework/select-search-material/select-search-material.component';
import { preferencias } from 'src/app/models/General/preferencias';
import { UserService } from 'src/app/servicios/user.service';

@Component({
  selector: 'app-preferencia-rent-a-car',
  templateUrl: './preferencia-rent-a-car.component.html',
  styleUrls: ['./preferencia-rent-a-car.component.scss']
})
export class PreferenciaRentACarComponent extends preferencias implements OnInit {

  @ViewChild('Grupo_Preferencia_RentACar_CompaniasAlquiler') Grupo_Preferencia_RentACar_CompaniasAlquiler: SelectSearchMaterialComponent;
  @ViewChild('Grupo_Preferencia_RentACar_Observaciones') Grupo_Preferencia_RentACar_Observaciones: ObservacionesComponent;
  @ViewChildren('Grupo_Preferencia_RentACar') grupos!: QueryList<GrupoPreferenciaComponent>;
  
  constructor(private _userService: UserService) {
    super();
  }

  ngOnInit(): void {
  }

  ETipoProducto = ETipoProducto;
  TipoPreferencia = ETipoPreferencia;

  @Input() preferencias: IPreferencia[];

  @Input() Companias: IItem[];

  @Input() CategoriasCoche: IItem[];

  @Input() clienteFicha: IFichaCliente;
  @Input() listaOtros: string[];
  contador: string = '0/100';

  //Actualizar contador para mostrar el número de letras ingresado hasta llegar al máximo
  actualizarContador(texto: string): void {
    const longitudMax: string | null = '100';
    const longitudAct: number = texto.length;
    this.contador = `${longitudAct}/${longitudMax}`;
  }

  //Obtener la lista de las preferencias rentACar guardadas
  obtenerPreferenciasGuardadas(): IPreferenciaCliente[] {

    let ListaPreferencias: IPreferenciaCliente[] = [];

    this.grupos.forEach((grupo) => {
      let resultado = grupo.obtenerPreferencias();
      let opcionesPreferencias: IPreferenciaCliente = {
        Tipo: grupo.Id,
        Preferencias: resultado[0],
        InfoEspecifica: resultado[1]
      };
      ListaPreferencias.push(opcionesPreferencias);
    });

    let RentAcarCompaniasAlquiler = this.Grupo_Preferencia_RentACar_CompaniasAlquiler.obtenerPreferencias()
    let CompaniasAlquilerRentACar: IPreferenciaCliente = {
      Tipo: this._userService.getTipoPreferenciasId('CompaniasCoche'),
      Preferencias: RentAcarCompaniasAlquiler,
      InfoEspecifica: null
    }
    ListaPreferencias.push(CompaniasAlquilerRentACar)

    let textoObservacion = this.Grupo_Preferencia_RentACar_Observaciones.obtenerPreferencias()
    let preferenciaRentACarObservaciones: IPreferenciaCliente = {
      Tipo: this._userService.getTipoPreferenciasId('ObservacionRentACar'),
      Preferencias: null,
      InfoEspecifica: textoObservacion,
    }
    ListaPreferencias.push(preferenciaRentACarObservaciones)

    return ListaPreferencias;
  }

  //Actualziar preferencias rentACar
  actualizar() {
    let preferencias = this.clienteFicha.Preferencias
    let preferenciasTipoRentACar = this.preferencias.filter(o => o.TipoProducto === ETipoProducto.RentAcar);
    let idsPreferencias = preferenciasTipoRentACar.map(o => o.Id);
    let resultado = preferencias.filter(o => idsPreferencias.includes(o.Tipo));
    this.grupos.forEach((grupo) => {
      const preferencia = resultado.find(p => p.Tipo === grupo.Id);
      if (preferencia) {
        grupo.actualizar(preferencia.Preferencias, preferencia.InfoEspecifica);
      }
    });

    let preferenciaCompaniasCoche: IPreferenciaCliente = this.obtenerPreferenciasCliente(preferencias, this._userService.getTipoPreferenciasId('CompaniasCoche'))
    let preferenciaTextoObservacionVehiculo: IPreferenciaCliente = this.obtenerPreferenciasCliente(preferencias, this._userService.getTipoPreferenciasId('ObservacionRentACar'))

    this.Grupo_Preferencia_RentACar_CompaniasAlquiler.actualizarSeleccion(preferenciaCompaniasCoche?.Preferencias);
    this.Grupo_Preferencia_RentACar_Observaciones.actualizar(preferenciaTextoObservacionVehiculo?.InfoEspecifica)
  }

  //Actualziar preferencias rentACar
  validarPreferencias() {
    let validacionPreferenciasRentACar = this.grupos.toArray().every(grupo => grupo.validarPreferencias());
    let estadoRentAcarCompaniasAlquiler = this.Grupo_Preferencia_RentACar_CompaniasAlquiler.validarPreferencias()
    return validacionPreferenciasRentACar && estadoRentAcarCompaniasAlquiler;
  }

}




